import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./PeakMark";

const links = [
  { label: "What we build", href: "/#philosophy", testId: "nav-link-what-we-build" },
  { label: "Mission", href: "/#mission", testId: "nav-link-mission" },
  { label: "Founder", href: "/#founder", testId: "nav-link-founder" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 border-b border-ink/5 bg-cream/90 backdrop-blur-md"
    >
      <nav className="mx-auto flex h-[72px] max-w-[1240px] items-center justify-between px-4 sm:px-6 lg:px-8" aria-label="Main navigation">
        <a href="/" data-testid="nav-brand-logo" aria-label="Build.Make.Win home" className="shrink-0">
          <Logo />
        </a>
        <div className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="font-body text-sm font-medium text-ink/80 underline-offset-4 transition-colors duration-200 hover:text-evergreen hover:underline"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://trycoacher.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-explore-coacher-btn"
            className="rounded-xl bg-growth px-5 py-2.5 font-display text-sm font-semibold text-white transition-colors duration-200 hover:bg-evergreen"
          >
            Explore CoachER
          </a>
        </div>
        <button
          type="button"
          data-testid="nav-menu-toggle"
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
          className="flex h-11 w-11 items-center justify-center rounded-xl border border-ink/10 text-ink md:hidden"
        >
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
      </nav>
      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-ink/5 bg-cream px-4 pb-6 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`${l.testId}-mobile`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 font-body text-base font-medium text-ink transition-colors hover:bg-sage/60"
              >
                {l.label}
              </a>
            ))}
            <a
              href="https://trycoacher.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-explore-coacher-btn-mobile"
              className="mt-2 rounded-xl bg-growth px-5 py-3 text-center font-display text-sm font-semibold text-white transition-colors hover:bg-evergreen"
            >
              Explore CoachER
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export const LegalTopBar = () => (
  <header className="border-b border-ink/5 bg-cream/90 backdrop-blur-md" data-testid="legal-topbar">
    <div className="mx-auto flex h-[72px] max-w-[1240px] items-center justify-between px-4 sm:px-6 lg:px-8">
      <Link to="/" data-testid="legal-brand-logo" aria-label="Build.Make.Win home">
        <Logo />
      </Link>
      <Link
        to="/"
        data-testid="legal-back-home-link"
        className="rounded-xl border border-evergreen/30 px-4 py-2 font-display text-sm font-semibold text-evergreen transition-colors duration-200 hover:bg-evergreen hover:text-white"
      >
        Back to home
      </Link>
    </div>
  </header>
);
